// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1__b0a5084c1b1da184627c","cls2":"LanguageSwitcherModal-cls2___fb110d28c1e3ce37ac7 LanguageSwitcherModal-cls1__b0a5084c1b1da184627c"};